"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionStream = Symbol('ACTION_STREAM');
exports.RxStoreConfig = Symbol('RX_STORE_CONFIG');
//# sourceMappingURL=tokens.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awaw00/rxstore/lib/tokens.js
// module id = 111
// module chunks = 0